import React from "react";
import { Box, Button, Text } from "@chakra-ui/react";

export const LascodalErrorPage = () => {
  return (
    <Box
      mt="0.3rem"
      background={"#FFFFFF"}
      maxW={"600px"}
      px={"25px"}
      py={"4rem"}
      mx="auto"
      display={"flex"}
    >
      <Box>
        <Text fontSize={"2rem"} fontWeight="bold">
          Oops! We ran into a problem
        </Text>
        <Text mt={"2rem"}>
          Something went wrong and we're already fixing the issue. Please try
          again later or send an email to <b>info@lascodalspellingbee.com</b> if
          this issue persists.
        </Text>
        <Button
          mt="2rem"
          py="0.5rem"
          px="2rem"
          bg="white"
          border="1.5px solid #050505"
          borderRadius="0.25rem"
          _hover={{ bg: "#050505", color: "white" }}
          onClick={() => {
            window.location.reload();
          }}
        >
          Refresh
        </Button>
      </Box>
    </Box>
  );
};
